import { useEffect, useState } from "react";

function TaskModal({ onClose, onSave, editTask }) {
  const [task, setTask] = useState({
    title: "",
    description: "",
    priority: "Low",
    status: "To-Do",
    dueDate: ""
  });

  useEffect(() => {
    if (editTask) setTask(editTask);
  }, [editTask]);

  const handleChange = (e) =>
    setTask({ ...task, [e.target.name]: e.target.value });

  const handleSubmit = () => {
    if (!task.title) return alert("Title required");
    onSave(task);
    onClose();
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.5)" }}>
      <div style={{ background: "#fff", padding: "20px", width: "320px", margin: "100px auto" }}>
        <h3>{editTask ? "Edit Task" : "Add Task"}</h3>

        <input name="title" value={task.title} placeholder="Title" onChange={handleChange} /><br />
        <input name="description" value={task.description} placeholder="Description" onChange={handleChange} /><br />

        <select name="priority" value={task.priority} onChange={handleChange}>
          <option>Low</option>
          <option>Medium</option>
          <option>High</option>
        </select><br />

        <select name="status" value={task.status} onChange={handleChange}>
          <option>To-Do</option>
          <option>In-Progress</option>
          <option>Completed</option>
        </select><br />

        <input type="date" name="dueDate" value={task.dueDate} onChange={handleChange} /><br /><br />

        <button onClick={handleSubmit}>{editTask ? "Update" : "Save"}</button>
        <button onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
}

export default TaskModal;